import { API_BASE_URL_AWARI } from '@/constants/api'
import { ModalsModel } from '@/models'
import setAuthorization from '@/utils/helpers/setAuthorization'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const modalsMentorshipsRepository = createApi({
	reducerPath: 'modalsMentorshipsRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL_AWARI,
	}),
	refetchOnReconnect: true,
	tagTypes: ['Modals'],

	endpoints: (builder) => ({
		list: builder.query<ModalsModel.ListMentorships, void>({
			query: () => ({
				url: `/modals`,
				method: 'GET',
			}),
			providesTags: ['Modals'],
		}),
	}),
})

export default modalsMentorshipsRepository
